import { render, staticRenderFns } from "./MatchItem.vue?vue&type=template&id=4bde4904&scoped=true&"
import script from "./MatchItem.vue?vue&type=script&lang=js&"
export * from "./MatchItem.vue?vue&type=script&lang=js&"
import style0 from "./MatchItem.vue?vue&type=style&index=0&id=4bde4904&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bde4904",
  null
  
)

export default component.exports